module.exports = __webpack_public_path__ + "static/media/im_empty.34a07e5e.svg";